module.exports = __webpack_public_path__ + "static/img/shine_pic3.f9d3a03.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/shine_pic3.png
// module id = /lT8
// module chunks = 1